<section class="remove-pet">
	<button
		class="o-modal-dismiss"
		mat-dialog-close
	>
		<epi-icon
			use="close"
			size="16"
			color="black"
		></epi-icon>
	</button>
	<epi-heading
		level="2"
		appears-as="2"
		color="inherit"
	>
		Confirm Remove Pet
	</epi-heading>
	<section class="remove-pet__content">
		Are you sure you want to remove {{ pet?.name }} from your policy?
	</section>
	<section class="remove-pet__actions">
		<button qeBaseButton color="primary" button-type="ghost"
			color="accent"
			class="primary-btn"
			[mat-dialog-close]="pet?.petId"
			data-gtm="removePetButton"
		>Yes, Remove Pet</button>
		<epi-button
			mat-dialog-close
			color="secondary"
			button-type="minimal"
			class="remove-pet__actions-item"
			(click)="dismiss()"
		>
			<epi-icon
				use="solid-plus-mark"
				color="secondary"
				size="18"
				class="remove-pet__actions-icon"
			></epi-icon>
			Cancel
		</epi-button>
	</section>
</section>
